import { call, put, select } from 'redux-saga/effects'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import { updateElectricityMeterModuleConfiguration } from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import * as Sentry from '@sentry/react'

export const pdlModuleActions = {
  METER_MODULE_REQUEST_PDL_DATA: 'METER_MODULE_REQUEST_PDL_DATA',
  METER_MODULE_VALIDATE_PDL_METER_SYNTAX: 'METER_MODULE_VALIDATE_PDL_METER_SYNTAX',
  METER_MODULE_LOAD_ENERGY_SUPPLIERS_ELEC: 'METER_MODULE_LOAD_ENERGY_SUPPLIERS_ELEC',
  RETRIEVE_PDL_CACHE_DATA: 'RETRIEVE_PDL_CACHE_DATA',
}

export function* requestPdlMeterData({ body }) {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { pod_eligibility_url: url } = yield select(selectPageConfigurationData)
  try {
    yield put(
      updateElectricityMeterModuleConfiguration({
        pdlEligibilityLoading: true,
        pdlEligibilityData: {},
      }),
    )
    const config = yield call(getAPIConfig, { method: 'post', authTokenSession, body })
    const response = yield call(fetch, url + '?lang=' + lang, config)
    yield call([response, response.json])
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'requestPdlMeterDataError' } })
    }
  }
}

export function* validatePdlMeterSyntax({ meterId, callback }) {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { pod_validate_url: url } = yield select(selectPageConfigurationData)
  const fullUrl = `${url}?lang=${lang}&meterId=${meterId}`
  try {
    const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
    const response = yield call(fetch, fullUrl, config)
    const result = yield call([response, response.json])
    if (response.status === 200) {
      yield call(callback, result)
    } else {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('validateMeterSyntaxError'), { extra: { result, status: response.status } })
      }
    }
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'validateMeterSyntaxError' } })
    }
  }
}
export function* retrievePdlCacheDataForKey({ key, route, subscriptionId, callback }) {
  const { authTokenSession, lang } = yield select(selectAuthData)
  try {
    const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
    const response = yield call(fetch, route + '/' + key + '/' + subscriptionId + '?lang=' + lang, config)
    const responseData = yield call([response, response.json])
    yield call(callback, responseData, response.status)
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'retrievePdlCacheDataForKeyError' } })
    }
  }
}

export function* loadElectricityEnergySuppliers() {
  const { authTokenSession, lang } = yield select(selectAuthData)
  const { load_supplier_options_url: url } = yield select(selectPageConfigurationData)
  const fullUrl = `${url}?lang=${lang}&energy=elec`

  try {
    const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
    const response = yield call(fetch, fullUrl, config)
    const isValid = response.status === 200
    const responseData = yield call([response, response.json])
    if (!isValid) {
      if (import.meta.env.PROD && response.status !== 422) {
        Sentry.captureException(new Error('loadElectricityEnergySuppliersError'), {
          extra: { responseData, status: response.status },
        })
      }
      return
    }
    yield put(updateElectricityMeterModuleConfiguration({ energySuppliers: responseData }))
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'loadElectricityEnergySuppliersError' } })
    }
  }
}
